// SF 監査カタログ（公式準拠53項目）の正本。frontend/backend 両方から参照する。
// 実 Salesforce/Bedrock 連携は後工程 — このファイルはデータ定義のみ。
import rawCatalog from "./catalog.json";

export type Severity = "critical" | "high" | "medium" | "low";
export type CheckCategory =
  | "identity-access"
  | "permissions-sharing"
  | "external-exposure"
  | "account-hygiene-audit";

export interface Check {
  readonly id: string;
  readonly category: CheckCategory;
  readonly title: string;
  readonly what: string;
  readonly why: string;
  readonly severity: Severity;
  readonly remediation: string;
  readonly salesforceReference: string;
}

export interface CategoryDef {
  readonly key: CheckCategory;
  readonly label: string;
  readonly description: string;
}

interface RawCatalog {
  readonly categories: readonly { key: string; label: string; description: string }[];
  readonly checks: readonly Check[];
}

const catalog = rawCatalog as unknown as RawCatalog;

export const SF_AUDIT_CHECKS: readonly Check[] = catalog.checks;
export const SF_AUDIT_CATEGORIES: readonly CategoryDef[] = catalog.categories.map((c) => ({
  key: c.key as CheckCategory,
  label: c.label,
  description: c.description,
}));
export const SF_AUDIT_CHECK_IDS: readonly string[] = catalog.checks.map((c) => c.id);
